import { render, staticRenderFns } from "./HomeNavbar.vue?vue&type=template&id=31a163b8"
import script from "./HomeNavbar.vue?vue&type=script&lang=js"
export * from "./HomeNavbar.vue?vue&type=script&lang=js"
import style0 from "./HomeNavbar.vue?vue&type=style&index=0&id=31a163b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports